
if (typeof FN == 'undefined') FN = {};

FN.config = {
  urls: {
    base: false,
    apiBase: false,
    newsletter: false,
    picturepuzzle: 'picture-puzzle',
    apiContactSubscribe: 'contacts/subscribe',
    apiContactUpdate: 'contacts/update'
  },
  analytics: {
    siteID: 'tower-blog',
    addPlatformToEventLabel: false
  }
};


FN.config.setEnvironmentUrls = function(type) {
  var urls = { 'base': false, 'apiBase': false };
  var host = window.location.host;

  if (host.indexOf('website-tower') === 0) {
    // development
    urls.base = '/';
    urls.apiBase = 'http://website-api.test/';
    urls.newsletter = 'http://website-api.test/contacts/subscribe';
  } else if (host.indexOf('staging.git-tower.com') === 0) {
    // staging
    urls.base = '/';
    urls.apiBase = 'https://staging.git-tower.com/api/';
    urls.newsletter = 'https://staging.git-tower.com/contacts/subscribe';
  } else {
    // production
    urls.base = '/blog/';
    urls.apiBase = 'https://www.git-tower.com/api/';
    urls.newsletter = 'https://www.git-tower.com/api/contacts/subscribe';
  }

  FN.config.urls.base = urls.base;
  FN.config.urls.apiBase = urls.apiBase;
  FN.config.urls.newsletter = urls.newsletter;
}
FN.config.setEnvironmentUrls();
